var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c("el-input", {
              staticClass: "width-2x",
              attrs: { type: "text" },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint block mb10" }, [
      _c("p", { staticClass: "font-red" }, [
        _vm._v("提示：系统会自动根据相同合同，同业务单元拆分多个验收单！")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("验收单标题")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-088f0e87", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-088f0e87","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/PurchReceiptSaveConfirm.vue
// module id = 3001
// module chunks = 0